/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorNewsletterSignup as ResolvedLabradorNewsletterSignup } from 'base/components/labrador/NewsletterSignup';

export const LabradorNewsletterSignup: typeof ResolvedLabradorNewsletterSignup = withLabradorInstanceof((props) => {
    return <ResolvedLabradorNewsletterSignup {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorNewsletterSignupProps = PropsFromComponent<typeof LabradorNewsletterSignup>;
